<template>
  <!-- Sidebar -->
  <!-- If you change the labels e.g. Billing etc, make sure to adjust the margins e.g. -ml-10 -->
  <div class="w-16 bg-SharesquareBackground shrink-0 items-center h-auto">
    <div
      class="flex flex-col w-full h-56 mt-28 shrink-0 justify-between items-start"
    >
      <button
        type="button"
        class="group relative flex justify-center items-center inline-block w-full h-full stroke-gray-600 hover:stroke-SharesquareBlue focus:outline-none hover:-translate-y-1 hover:scale-110 hover:text-SharesquareBlue duration-300"
        @click="goHome"
      >
        <PresentationChartBarIcon
          stroke="SharesquareBlue"
          class="h-7 w-7 block"
        />
        <span
          class="absolute flex hidden whitespace-nowrap group-hover:flex w-auto inline-block px-2 py-1 bg-gray-700 rounded-md text-center justify-center text-white text-sm translate-x-full before:content-[''] before:absolute before:top-1/2 before:right-[100%] before:-translate-y-1/2 before:border-4 before:border-y-transparent before:border-1-transparent before:border-r-gray-700 left-2"
        >
          Home
        </span>
      </button>

      <button
        v-if="!authStore.isReadOnly"
        type="button"
        class="group relative flex justify-center items-center inline-block w-full h-full stroke-gray-600 hover:stroke-SharesquareBlue focus:outline-none hover:-translate-y-1 hover:scale-110 hover:text-SharesquareBlue duration-300"
        @click="creatNewPlan"
      >
        <DocumentPlusIcon stroke="SharesquareBlue" class="h-7 w-7 block" />
        <span
          class="absolute flex hidden whitespace-nowrap group-hover:flex w-auto inline-block px-2 py-1 bg-gray-700 rounded-md text-center justify-center text-white text-sm translate-x-full before:content-[''] before:absolute before:top-1/2 before:right-[100%] before:-translate-y-1/2 before:border-4 before:border-y-transparent before:border-1-transparent before:border-r-gray-700 -left-7"
        >
          {{ $t('COMPONENT_DASHBOARD_OWNER_CREATE_PLAN') }}
        </span>
      </button>
      <button
        v-if="false"
        type="button"
        class="group relative flex justify-center items-center inline-block w-full h-full stroke-gray-600 hover:stroke-SharesquareBlue focus:outline-none hover:-translate-y-1 hover:scale-110 hover:text-SharesquareBlue duration-300"
        @click="openKnowledgeBase"
      >
        <AcademicCapIcon stroke="SharesquareBlue" class="h-7 w-7 block" />
        <span
          class="absolute flex hidden whitespace-nowrap group-hover:flex w-auto inline-block px-2 py-1 bg-gray-700 rounded-md text-center justify-center text-white text-sm translate-x-full before:content-[''] before:absolute before:top-1/2 before:right-[100%] before:-translate-y-1/2 before:border-4 before:border-y-transparent before:border-1-transparent before:bg-SharesquareBackground before:border-r-gray-700 -ml-2"
        >
          {{ $t('COMPONENT_LAYOUT_HEADER_KNOWLEDGE_BASE') }}
        </span>
      </button>
      <button
        v-if="!authStore.isReadOnly"
        type="button"
        class="group z-10 relative flex justify-center items-center inline-block w-full h-full stroke-gray-600 hover:stroke-SharesquareBlue focus:outline-none hover:-translate-y-1 hover:scale-110 hover:text-SharesquareBlue duration-300"
        @click="openUsers"
      >
        <KeyIcon stroke="SharesquareBlue" class="h-7 w-7 block" />
        <span
          class="absolute flex hidden whitespace-nowrap group-hover:flex w-auto inline-block px-2 py-1 bg-gray-700 rounded-md text-center justify-center text-white text-sm translate-x-full before:content-[''] before:absolute before:top-1/2 before:right-[100%] before:-translate-y-1/2 before:border-4 before:border-y-transparent before:border-1-transparent before:bg-SharesquareBackground before:border-r-gray-700 -ml-0"
        >
          Access
        </span>
      </button>
      <button
        type="button"
        class="group relative flex justify-center items-center inline-block w-full h-full stroke-gray-600 hover:stroke-SharesquareBlue focus:outline-none hover:-translate-y-1 hover:scale-110 hover:text-SharesquareBlue duration-300"
        @click="openBilling"
      >
        <WalletIcon stroke="SharesquareBlue" class="h-7 w-7 block" />
        <span
          class="absolute flex hidden whitespace-nowrap group-hover:flex w-auto inline-block px-2 py-1 bg-gray-700 rounded-md text-center justify-center text-white text-sm translate-x-full before:content-[''] before:absolute before:top-1/2 before:right-[100%] before:-translate-y-1/2 before:border-4 before:border-y-transparent before:border-1-transparent before:bg-SharesquareBackground before:border-r-gray-700 ml-2"
        >
          Billing
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import {
  AcademicCapIcon,
  PresentationChartBarIcon,
  DocumentPlusIcon,
  WalletIcon,
  KeyIcon,
} from '@heroicons/vue/24/outline'
import { useAuthStore } from '~/store/auth/state'
export default {
  name: 'Sidebar',
  components: {
    AcademicCapIcon,
    PresentationChartBarIcon,
    DocumentPlusIcon,
    WalletIcon,
    KeyIcon,
  },
  data() {
    return {
      authStore: useAuthStore(),
      kbToken: null,
    }
  },
  methods: {
    openKnowledgeBase() {
      this.$router.push({ name: 'knowledge-base' })
    },
    openUsers() {
      this.$router.push({ name: 'users' })
    },
    openBilling() {
      this.$router.push({ name: 'billing-and-plans' })
    },
    goHome() {
      this.$router.push({ path: '/' })
    },
    creatNewPlan() {
      this.$router.push({ path: '/create-plan-wizard/create/new' })
    },
  },
}
</script>
